import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::index
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:62
* @route '/api/admin/professional-roles'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/api/admin/professional-roles',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::index
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:62
* @route '/api/admin/professional-roles'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::index
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:62
* @route '/api/admin/professional-roles'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::index
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:62
* @route '/api/admin/professional-roles'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::store
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:72
* @route '/api/admin/professional-roles'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/api/admin/professional-roles',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::store
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:72
* @route '/api/admin/professional-roles'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::store
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:72
* @route '/api/admin/professional-roles'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::show
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:67
* @route '/api/admin/professional-roles/{professionalRole}'
*/
export const show = (args: { professionalRole: number | { id: number } } | [professionalRole: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/api/admin/professional-roles/{professionalRole}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::show
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:67
* @route '/api/admin/professional-roles/{professionalRole}'
*/
show.url = (args: { professionalRole: number | { id: number } } | [professionalRole: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { professionalRole: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { professionalRole: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            professionalRole: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        professionalRole: typeof args.professionalRole === 'object'
        ? args.professionalRole.id
        : args.professionalRole,
    }

    return show.definition.url
            .replace('{professionalRole}', parsedArgs.professionalRole.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::show
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:67
* @route '/api/admin/professional-roles/{professionalRole}'
*/
show.get = (args: { professionalRole: number | { id: number } } | [professionalRole: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::show
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:67
* @route '/api/admin/professional-roles/{professionalRole}'
*/
show.head = (args: { professionalRole: number | { id: number } } | [professionalRole: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::update
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:82
* @route '/api/admin/professional-roles/{professionalRole}'
*/
export const update = (args: { professionalRole: number | { id: number } } | [professionalRole: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/api/admin/professional-roles/{professionalRole}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::update
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:82
* @route '/api/admin/professional-roles/{professionalRole}'
*/
update.url = (args: { professionalRole: number | { id: number } } | [professionalRole: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { professionalRole: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { professionalRole: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            professionalRole: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        professionalRole: typeof args.professionalRole === 'object'
        ? args.professionalRole.id
        : args.professionalRole,
    }

    return update.definition.url
            .replace('{professionalRole}', parsedArgs.professionalRole.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::update
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:82
* @route '/api/admin/professional-roles/{professionalRole}'
*/
update.put = (args: { professionalRole: number | { id: number } } | [professionalRole: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::destroy
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:92
* @route '/api/admin/professional-roles/{professionalRole}'
*/
export const destroy = (args: { professionalRole: number | { id: number } } | [professionalRole: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/api/admin/professional-roles/{professionalRole}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::destroy
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:92
* @route '/api/admin/professional-roles/{professionalRole}'
*/
destroy.url = (args: { professionalRole: number | { id: number } } | [professionalRole: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { professionalRole: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { professionalRole: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            professionalRole: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        professionalRole: typeof args.professionalRole === 'object'
        ? args.professionalRole.id
        : args.professionalRole,
    }

    return destroy.definition.url
            .replace('{professionalRole}', parsedArgs.professionalRole.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfessionalRoleController::destroy
* @see app/Http/Controllers/Admin/ProfessionalRoleController.php:92
* @route '/api/admin/professional-roles/{professionalRole}'
*/
destroy.delete = (args: { professionalRole: number | { id: number } } | [professionalRole: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const professionalRoles = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default professionalRoles